export enum Experience {
    showOnlySales = 'SALES',
    showOnlyCustomerService = 'CUSTOMERSERVICE',
    callMe = 'CALLME',
    callMeTermination = 'CALLMETERMINATION',
    default = 'DEFAULT',
}
